import React from 'react';
import { Section } from './ui/Section';
import { GraduationCap, Clock, FileText, ShieldCheck } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function WhyChooseUs() {
  const {
    t
  } = useLang();
  const reasons = [{
    icon: GraduationCap,
    titleKey: 'why1_title',
    descKey: 'why1_desc'
  }, {
    icon: Clock,
    titleKey: 'why2_title',
    descKey: 'why2_desc'
  }, {
    icon: FileText,
    titleKey: 'why3_title',
    descKey: 'why3_desc'
  }, {
    icon: ShieldCheck,
    titleKey: 'why4_title',
    descKey: 'why4_desc'
  }];
  return <Section id="why-us" background="gray" data-id="element-316">
      <div className="mb-16 md:mb-24" data-id="element-317">
        <h2 className="text-3xl md:text-5xl font-bold text-black mb-6" data-id="element-318">
          {t('why_h2')}
        </h2>
        <div className="h-px w-full bg-neutral-200" data-id="element-319"></div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8" data-id="element-320">
        {reasons.map((reason, index) => <div key={index} className="group relative pb-4 border border-neutral-200 p-6 md:p-8" data-id="element-321">
            <div className="relative z-10" data-id="element-322">
              <div className="mb-6 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-323">
                <reason.icon className="h-8 w-8 text-black stroke-[1.5]" data-id="element-324" />
              </div>
              <h3 className="text-xl font-bold text-black mb-4 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-325">
                {t(reason.titleKey)}
              </h3>
              <p className="text-neutral-500 leading-relaxed text-sm" data-id="element-326">
                {t(reason.descKey)}
              </p>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-px bg-black group-hover:w-full transition-all duration-500" data-id="element-327"></div>
          </div>)}
      </div>
    </Section>;
}